/* Program Name: generalFunctions.js
 **  Description: a file containing a list of general functions
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** SD6391     2025-01-30  SGS  SD9399 - Promo - Item price is on the item grid
 *********************************************************************************/

export const makeTree = (array, parentId) => {
  var map = {},
    node,
    roots = [],
    i
  // if(typeof array === "undefined") return
  for (i = 0; i < array.length; i += 1) {
    map[array[i].id] = i
    if (!array[i].children) array[i].children = []
  }

  for (i = 0; i < array.length; i += 1) {
    node = array[i]
    if (node[parentId] !== null) {
      try {
        array[map[node[parentId]]].children.push(node)
      } catch (error) {}
    } else {
      roots.push(node)
    }
  }
  return roots
}

export const formatCurrency = (decimal) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(decimal)
}
